export default __webpack_public_path__ + "media/images/advan-icon/clock-c1599a5f05fa4d42fd5c1727d54b4950.png";